module.exports = __webpack_public_path__ + "img/V24.5a7ace89.png";